<div class="w-full">
  <div class="w-full flex items-center">
    <div class="flex items-center justify-between gap-5 px-2 pl-5 py-3 border-b border-proffeo-border w-full">
      <div class="flex w-full justify-between items-center gap-5">
        <div class="flex items-center gap-1.5">
          <mat-icon fontIcon="business_center" />

          <span class="text-xl">{{ projectName() }}</span>
        </div>
        <div class="flex gap-5 items-center">
          <proffeo-ui-button
            (click)="openDuplicateProjectLocationDialog()"
            [disabled]="selectedLocations().length === 0"
            variant="primary"
            text="project-locations.actions.duplicate-multiple"
          ></proffeo-ui-button>
          <button
            [matMenuTriggerFor]="matUserMenu"
            [attr.aria-label]="'project-locations.actions.more-actions' | translate"
            mat-icon-button
            type="button"
          >
            <mat-icon
              aria-hidden="true"
              fontIcon="more_vert"
              class="more-actions-icon"
            />
          </button>
        </div>
        <mat-menu #matUserMenu>
          <button
            (click)="openAddMultipleLocationDialog()"
            mat-menu-item
            proffeoMenuAction
          >
            <mat-icon fontIcon="add_location_alt" />
            <span>{{ 'project-locations.actions.add-multiple-sublocations' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  @if (locationNodes().length) {
    <ng-template
      #locationContentTemplate
      let-location
    >
      <proffeo-project-location-item [location]="location" />
    </ng-template>

    <proffeo-ui-sortable-tree
      [(selectedRows)]="selectedLocations"
      (reorder)="reorderLocations($event)"
      [compareWith]="compareLocations"
      [contentTemplate]="locationContent()"
      [listAriaLabel]="'project-locations.columns.location' | translate"
      [nodes]="locationNodes()"
      [rowDraggable]="isLocationEditable"
      [rowSelectable]="isLocationEditable"
      [selectable]="true"
    />
  }
</div>
